import React, { useState } from "react";
import {
  Container,
  Row,
  Card,
  CardHeader,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardFooter,
  Spinner,
} from "reactstrap";
import CustomPagination from "./CustomPagination";
import { put } from "utils/api";
import { useLocation } from "react-router-dom";

const DynamicTable = ({
  data,
  setData,
  listName,
  allowedSortFields,
  totalData,
  setPageNo,
  pageNo,
  dropdown,
  options,
  clickOnViewMore,
  clickOnOrderHistory,
  clickOnRunningSerice,
  clickOnPakageInfomation,
  clickOnActiveDeactive,
  loading,
  buttonText,
  buttonOnClick,
}) => {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedOption, setSelectedOption] = useState([]);
  const location = useLocation();

  const handleSort = (column) => {
    if (allowedSortFields.includes(column)) {
      if (sortColumn === column) {
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
      } else {
        setSortColumn(column);
        setSortOrder("asc");
      }
    }
  };

  const sortedData = [...data].sort((a, b) => {
    if (!sortColumn) return 0;

    const aValue = a[sortColumn];
    const bValue = b[sortColumn];

    if (aValue == null || bValue == null) return 0;

    if (typeof aValue === "number" && typeof bValue === "number") {
      return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
    }

    return sortOrder === "asc"
      ? String(aValue).localeCompare(String(bValue))
      : String(bValue).localeCompare(String(aValue));
  });

  const renderOptions = (index, status) => {
    const statusStr = status ? status.toString() : "inactive";
    const isActive = statusStr === "active";

    return (
      <UncontrolledDropdown>
        <DropdownToggle
          className="btn-icon-only text-light"
          role="button"
          size="sm"
          color=""
          onClick={(e) => e.preventDefault()}
        >
          <i className="fas fa-ellipsis-v" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-arrow" right>
          <DropdownItem key={index} value={index} onClick={clickOnViewMore}>
            View detail
          </DropdownItem>
          <DropdownItem value={index} onClick={clickOnOrderHistory}>
            Order history
          </DropdownItem>
          <DropdownItem value={index} onClick={clickOnRunningSerice}>
            Running services
          </DropdownItem>

          {(location?.pathname === "/admin/furniture-company-list" ||
            location?.pathname === "/admin/cleaning-company-list") && (
            <DropdownItem value={index} onClick={clickOnPakageInfomation}>
              Package information
            </DropdownItem>
          )}

          {location.pathname === "/admin/home_owner" && (
            <DropdownItem value={index} onClick={clickOnPakageInfomation}>
              House List information
            </DropdownItem>
          )}

          <DropdownItem
            value={index}
            data-status={statusStr}
            data-key={["locked", "inactive", "suspended"].includes(statusStr)
              ? "active"
              : "inactive"}
            style={{ color: isActive ? "red" : "green" }}
            onClick={clickOnActiveDeactive}
          >
            {isActive ? "In-activate" : "Activate"}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  };

  const handleDropdownChange = (newValue, selectedIndex, itemId) => {
    const dataList = { user_id: itemId, status: newValue };

    put("/api/user/update-account-status", dataList)
      .then((response) => {
        if (response.statusCode === 200) {
          setSelectedOption((prev) => {
            const newArr = [...prev];
            newArr[selectedIndex] = newValue;
            return newArr;
          });

          const updatedData = data.map((item) =>
            item.id === itemId ? { ...item, status: newValue } : item
          );
          setData(updatedData);
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <Container className="mt--7" fluid>
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0">
              <div className="d-flex">
                <h3 className="mr-auto">{listName}</h3>
                {buttonText && buttonOnClick && (
                  <button
                    className="btn btn-primary"
                    onClick={buttonOnClick}
                  >
                    {buttonText}
                  </button>
                )}
              </div>
            </CardHeader>

            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Sr. No</th>

                  {data?.length > 0 &&
                    Object.keys(data[0]).map(
                      (key, index) =>
                        key !== "id" && (
                          <th
                            key={index}
                            scope="col"
                            onClick={() => handleSort(key)}
                          >
                            {key.split("_").join(" ")}{" "}
                            {allowedSortFields.includes(key) &&
                              sortColumn === key &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </th>
                        )
                    )}

                  <th scope="col" />
                </tr>
              </thead>

              {!loading && (
                <tbody>
                  {sortedData.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNo - 1) * 10 + (index + 1)}</td>

                      {Object.entries(item).map(
                        ([key, value], idx) =>
                          key !== "id" && (
                            <td key={idx}>
                              {key === "status" ? (
                                <div>
                                  {dropdown ? (
                                    React.cloneElement(dropdown, {
                                      options,
                                      selectedOption:
                                        selectedOption[index] ||
                                        String(value || ""),
                                      setSelectedOption: (newValue) =>
                                        handleDropdownChange(
                                          newValue,
                                          index,
                                          item.id
                                        ),
                                    })
                                  ) : (
                                    <span>{String(value || "N/A")}</span>
                                  )}
                                </div>
                              ) : (
                                <span>{String(value || "N/A")}</span>
                              )}
                            </td>
                          )
                      )}

                      <td className="text-dark">
                        {renderOptions(item.id, item.status)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>

            {!loading && (
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <CustomPagination
                    totalItems={totalData}
                    itemsPerPage={10}
                    currentPage={pageNo}
                    onPageChange={(page) => setPageNo(page)}
                  />
                </nav>
              </CardFooter>
            )}

            {loading && (
              <div className="text-center my-4">
                <Spinner color="primary" />
              </div>
            )}
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default DynamicTable;
